import { render } from "./PageIndex.vue?vue&type=template&id=00158843"
import script from "./PageIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PageIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/email/components/PageIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00158843"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00158843', __exports__)) {
    api.reload('00158843', __exports__)
  }
  
  module.hot.accept("./PageIndex.vue?vue&type=template&id=00158843", () => {
    api.rerender('00158843', render)
  })

}


export default __exports__